import React from "react";
import allInOneImage from "../../assets/images/all-in-one.png";

const MiniFactorySection = () => (
  <section className="mini-factory-section">
    <div className="mini-factory-container">
      <div className="mini-factory-text">
        <h2 className="mini-factory-heading">
          We equip classrooms with plug-n-play Mini-Factory that enables
          hands-on learning of Industry 4.0 technologies.
        </h2>
        <p className="mini-factory-description">
          Founded with a vision to empower smart manufacturing and smart
          learning, Terafac Technologies was established in 2021.
        </p>
      </div>
      <div className="mini-factory-image">
        <img src={allInOneImage} alt="Mini Factory" />
      </div>
    </div>
  </section>
);

export default MiniFactorySection;
